import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-composition-app-detail-menu-items',
    templateUrl: './composition-app-detail-menu-items.component.html',
    styleUrls: ['./composition-app-detail-menu-items.component.scss'],
    providers: [],
    standalone: false
})
export class CompositionAppDetailMenuItemsComponent implements OnInit {

  @Input() translation: any;
  @Input() language: string;
  @Input() importerByMenuItems: Map<string, Models.Import>;
  @Output() save: EventEmitter<any> = new EventEmitter();

  public assignedItems = [];

  constructor() {
  }

  ngOnInit() {
    if (!this.importerByMenuItems) {
      return;
    }
    this.translation.items.map(id => {
      const importer = this.importerByMenuItems.get(id);
      if (importer) {
        this.assignedItems.push({
          title: importer.detail.title || importer.title,
          importTitle: importer.title,
          importId: importer._id,
        })
      } else if (id.menuItemIds) {
        this.assignedItems.push({ title: id.title });
      } else {
        this.assignedItems.push({ title: id });
      }
    })
  }

  public dropItem(event: any) {
    if (event.previousIndex !== event.currentIndex) {
      const draggedItem = this.assignedItems.splice(event.previousIndex, 1)[0] as any;
      this.assignedItems.splice(event.currentIndex, 0, draggedItem);
      const item = this.translation.items.splice(event.previousIndex, 1)[0];
      this.translation.items.splice(event.currentIndex, 0, item);
      this.save.emit({ language: this.language, menuItemIds: this.translation.menuItemIds, items: this.translation.items });
    }
  }

}
